module.exports = __webpack_public_path__ + "img/chuji.77c3ae95.png";